const ContactService = {
  convertInterestsToString(interests) {
    if (Array.isArray(interests)) {
      return interests.map(i => i.value).join(',');
    }
    return interests;
  },
  async saveContact(formData) {
    try {
      let url = '/api/contacts';
      let method = 'POST';
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      if (formData.identifier !== undefined) {

        url = '/api/contacts/' + formData.identifier;
        method = 'PUT';
      }
      const updatedData = {
        ...formData, 
        where: formData.where.value,
        who: formData.who.value,
        accountIdentifier: accountIdentifier,
        interests: this.convertInterestsToString(formData.interests)
      }
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newContact = await response.json();
        console.log('Contact has been updated:', newContact);
      }
    } catch (error) {
      console.log('Error saving Contact', error);
    }
  },
  async retrieveAllContactsByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/contacts/account/' + accountIdentifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Contact', error);
      throw error;
    }
  },
  async retrieveContact(identifier) {
    try {
      const response = await fetch('/api/contacts/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Contact', error);
      throw error;
    }
  },
  async deleteContact(identifier) {
    try {
      let url = '/api/contacts';
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newContact = await response.json();
        console.log('Contact has been deleted:', newContact);
      }
    } catch (error) {
      console.log('Error deleting Contact', error);
    }
  }
};
export default ContactService;